<div *ngIf="displayedText"
     class="banner banner_secondary">
  <div class="banner-content">
    <mat-icon class="banner-content-icon">error_outline</mat-icon>
    <p>{{ displayedText }}</p>
  </div>
</div>
